/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import SimpleTooltip from '../../../simple-tooltip';

export interface ToolbarIconProps {
  src?: string;
  alt?: string;
  tooltip: string;
};

const ToolbarIcon = (props: ToolbarIconProps) => {
  const { src, alt, tooltip } = props;
  return <div className='fixed-icon'>
    <SimpleTooltip text={tooltip}>
      <img src={src} alt={alt} />
    </SimpleTooltip>
  </div>
}

export default ToolbarIcon;
